<template>
  <div v-if="item.menuType !== 2" class="menu-sidebar-item">
    <template v-if="!hasChildren">
      <app-link :to="item.link" :class="{'is-first-active': isFirstActive(item)}">
        <el-menu-item :index="item.link" class="submenu-title-noDropdown">
          <div class="submenu-box">
            <item :icon="iconClass" :title="menuName" />
          </div>
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu
      v-else
      ref="subMenu"
      :index="item.link"
      :class="{'is-first-active': isFirstActive(item)}"
      popper-append-to-body
      popper-class="second-submenu-container"
    >
      <template slot="title">
        <item :icon="iconClass" :title="menuName" />
      </template>
      <el-scrollbar wrap-class="second-scrollbar-wrapper">
        <el-menu
          :unique-opened="true"
          :default-active="activeIndex"
        >
          <second-menu
            v-for="(child, k) in formatMenu(item.childNode)"
            :key="child.id"
            :is-nest="true"
            :data="child"
            :child-index="`${index}-${k}`"
            :current-path="currentPath"
            @updateActiveIndex="updateActiveIndex"
          />
        </el-menu>
      </el-scrollbar>
    </el-submenu>
  </div>
</template>

<script>
import Item from './Item.vue'
import AppLink from './Link.vue'
import SecondMenu from './SecondMenu.vue'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink, SecondMenu },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      default: ''
    },
    currentPath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeIndex: ''
    }
  },
  computed: {
    iconClass() {
      return this.item.iconClass
    },
    menuName() {
      if (this.item) {
        if (this.item.menuKey === 'home') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.home')
        }
        if (this.item.menuKey === 'aboutIndex') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.contractManagementMenu')
        }
        if (this.item.menuKey === 'freight') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.rateManagementMenu')
        }
        if (this.item.menuKey === 'surcharge') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.surchargeManagementMenu')
        }
        if (this.item.menuKey === 'cabin') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.distributionManagementMenu')
        }
        if (this.item.menuKey === 'tag') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.tagManagement')
        }
        if (this.item.menuKey === 'premium') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.markupManagement')
        }
        if (this.item.menuKey === 'free') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.freeDetentionMenu')
        }
        if (this.item.menuKey === 'prebooking') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.prebookingMenu')
        }
        if (this.item.menuKey === 'bulkCargo') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.generalCargoSchedule')
        }
        if (this.item.menuKey === 'rms') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.authorityMenu')
        }
        if (this.item.menuKey === 'systemSetting') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.systemSettingMenu')
        }
        if (this.item.menuKey === 'ali_quickbi_gigarate') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.dataBI')
        }
        if (this.item.menuKey === 'subscribe') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.rateSubscribed')
        }
        if (this.item.menuKey === 'offlineRate') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.offlineRateMenu')
        }
        if (this.item.menuKey === 'inlandCarriage') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.inlandFreightMenuNew')
        }
        if (this.item.menuKey === 'inlandDetails') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.inlandFreightDetails')
        }
        if (this.item.menuKey === 'queryLog') {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.item.menuName = this.$t('msg.searchRecs')
        }
      }
      return this.item.menuName
    },
    hasChildren() {
      const childNode = this.item.childNode || []
      const showChildren = childNode.filter(item => {
        if (item.menuType === 2) {
          return false
        } else {
          return true
        }
      })
      if (showChildren.length === 1) {
        return true
      }
      if (showChildren.length === 0) {
        return false
      }
      return true
    },
    variables() {
      return document.body.style.getPropertyValue('--geek-color-subMenuBar').trim()
    }
  },
  methods: {
    isFirstActive(v) {
      if (v.menuKey && this.currentPath.indexOf('/' + v.menuKey) > -1) {
        return true
      } else {
        return false
      }
    },
    updateActiveIndex(val) {
      this.activeIndex = val
    },
    formatMenu(arr) {
      if (arr && arr.length > 0) {
        arr.forEach(item => {
          if (item.menuKey === 'freightProprietary') {
            item.menuName = this.$t('msg.contractRateMenu')
          }
          if (item.menuKey === 'freightOnline') {
            item.menuName = this.$t('msg.eCommerceRateMenu')
          }
          if (item.menuKey === 'freightPeer') {
            item.menuName = this.$t('msg.offlineRateMenu')
          }
          if (item.menuKey === 'product') {
            item.menuName = this.$t('msg.productManagementMenu')
          }
          if (item.menuKey === 'freightAll') {
            item.menuName = this.$t('msg.rateTotalTableMenu')
          }
          if (item.menuKey === 'freightRecords') {
            item.menuName = this.$t('msg.rateRecordsMenu')
          }
          if (item.menuKey === 'surchargeRules') {
            item.menuName = this.$t('msg.surchargeRulesMenu')
          }
          if (item.menuKey === 'surchargeDetails') {
            item.menuName = this.$t('msg.surchargeDetailsMenu')
          }
          if (item.menuKey === 'inlandFreight') {
            item.menuName = this.$t('msg.inlandFreightMenuNew')
          }
          if (item.menuKey === 'cabinList') {
            item.menuName = this.$t('msg.distributionRateMenu')
          }
          if (item.menuKey === 'CabinRules') {
            item.menuName = this.$t('msg.distributionMarkupTitle')
          }
          if (item.menuKey === 'cabinAutomatic') {
            item.menuName = this.$t('msg.automaticDistributionRateMenu')
          }
          if (item.menuKey === 'rms_form') {
            item.menuName = this.$t('msg.organizationMenu')
          }
          if (item.menuKey === 'rms_role_power') {
            item.menuName = this.$t('msg.rolePermissionManagementMenu')
          }
          if (item.menuKey === 'rms-data') {
            item.menuName = this.$t('msg.dataAuthorityManagementMenu')
          }
          if (item.menuKey === 'ali_quickbi_gigarate') {
            item.menuName = this.$t('msg.dataBI')
          }
          if (item.menuKey === 'subscribe') {
            item.menuName = this.$t('msg.dataBI')
          }
          if (item.menuKey === 'offlineRate') {
            item.menuName = this.$t('msg.offlineRateMenu')
          }
          if (item.menuKey === 'inlandCarriage') {
            item.menuName = this.$t('msg.inlandFreightMenuNew')
          }
          if (item.menuKey === 'inlandDetails') {
            item.menuName = this.$t('msg.inlandFreightDetails')
          }
        })
      }
      return arr
    }
  }
}
</script>
<style lang="scss">
@import '../../../../styles/variables.scss';
.el-submenu .el-submenu__title {
  display: flex;
  flex-direction: column;
  height: 54px;
  line-height: 1;
  align-items: center;
  justify-content: center;
}
.nest-menu .menu-item-li-height{
  height: 30px !important;
  line-height: 30px;
}

.yld-sub-menu {
  .el-submenu__title{
    height: 30px;
    line-height: 30px;
    display: flex;
    flex-direction: row;
    text-align: left;
  }
}

.el-menu--popup {
  overflow-y: visible !important;
  .yun-menu-icon {
    font-size: 14px;
    vertical-align: middle;
    margin-right: 20px;
    color:var(--geek-color-menuTextColor) !important;
  }
  .menu-sidebar-item {
    height: auto !important;
  }
  .el-submenu__title,
  .el-menu-item {
    justify-content: flex-start;
  }
  .el-menu-item:hover{
    background: var(--geek-color-subMenuHover) !important;
  }
}
.el-menu-item {
  height: 54px !important;
  &:hover {
    .yun-menu-icon {
      color: var(--geek-color-menuTextColor);
    }
  }
  align-items: center;
  display: flex;
  justify-content: center;
  span {
    font-size: 13px;
    color: var(--geek-color-menuTextColor);
  }
}
.el-submenu__title {
  color: var(--geek-color-menuTextColor) !important;
  &:hover {
    .yun-menu-icon, i {
      color: var(--geek-color-menuTextColor);
    }
  }
}
.submenu-box {
  align-items: center;
  line-height: 1;
  .yun-menu-icon {
    margin-bottom: 3px;
    color:var(--geek-color-menuTextColor);
  }
}

.second-submenu-container {
  z-index: 4000 !important;
  height: 100vh;
  top: 0 !important;
  transform-origin: center;
  opacity: 1;
  ul {
    padding: 0;
    margin: 0;
  }
  .el-menu--popup {
    height: 100%;
    background: var(--geek-color-subMenuBar) !important;
  }
  .el-menu {
    border-right: none;
  }
}
.second-submenu-container.el-zoom-in-left-enter-active, .second-submenu-container.el-zoom-in-left-leave-active {
   opacity: 1;
  transition: none 0 !important;
  transform: none !important;
}
.second-submenu-container.el-zoom-in-left-enter, .second-submenu-container.el-zoom-in-left-leave {
  opacity: 1;
  transition: none 0 !important;
  transform: none !important;
}
.second-submenu-container.el-zoom-in-left-leave-to {
   opacity: 1;
  transition: none 0 !important;
  transform: none !important;
}
.second-scrollbar-wrapper {
  .el-menu {
    background-color: var(--geek-color-subMenuBar) !important;
  }
  .router-link-active {
    & > .el-menu-item {
        background: var(--geek-color-subMenuHover) !important;
      }
  }
  .el-submenu__title {
    height: 44px;
    line-height: 44px;
  }
  i {
    color: var(--geek-color-menuTextColor) !important;
    font-size: 16px;
  }
   .yun-menu-icon {
     color: var(--geek-color-menuTextColor) !important;
      font-size: 16px;
      margin-right: 13px;
   }
   .el-submenu {
     .el-menu-item {
       color: var(--geek-color-menuTextColor);
       font-size: 13px;
       height: 44px !important;
       line-height: 44px !important;
     }
   }
}
</style>
